"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/*
* Copyright (c) Trainline Limited, 2017. All rights reserved.
* See LICENSE.txt in the project root for license information.
*/
var React = require("react");
var utils_1 = require("./utils");
function createSkeletonProvider(dummyData, predicate, styling) {
    return function (
        // tslint:disable-next-line:max-line-length
        // tslint:disable-next-line:no-any
        WrappedComponent
        // tslint:disable-next-line:no-any
    ) {
        var ExportedComponent = (function (_super) {
            __extends(ExportedComponent, _super);
            function ExportedComponent() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.getChildContext = function () { return ({
                    skeletor: {
                        isPending: predicate(_this.props),
                        styling: styling,
                    },
                }); };
                return _this;
            }
            ExportedComponent.prototype.render = function () {
                var props = this.props;
                // Append dummy data only if the condition defined by the predicate are met,
                // by default if there is no predicate, append the data.
                if (predicate ? predicate(props) : true) {
                    // Either call the dummyData as a function or assign dummyData to data
                    var data = typeof dummyData === 'function' ? dummyData(props) : dummyData;
                    // TODO: fix with typescript 2.4
                    return React.createElement(WrappedComponent, Object.assign({}, props, data));
                }
                // TODO: fix with typescript 2.4
                return React.createElement(WrappedComponent, props);
            };
            return ExportedComponent;
        }(React.Component));
        ExportedComponent.childContextTypes = utils_1.contextTypes;
        return ExportedComponent;
    };
}
exports.createSkeletonProvider = createSkeletonProvider;
//# sourceMappingURL=createSkeletonProvider.js.map


//////////////////
// WEBPACK FOOTER
// /Users/alexandrer/development/react-skeletor/lib/createSkeletonProvider.js
// module id = 313
// module chunks = 0